<script>

    import { toast } from 'bulma-toast'
    import { replace, location } from "svelte-spa-router"
    import { createEventDispatcher } from 'svelte'
    import Moment from 'moment'

    import { userStore, popupStore, notifyStore } from '../stores'

    import Merchandises from '../merchandises/component.merchandises.list.svelte'
    import ShipmentsService from '../$services/shipments.service'
    import OrdersService from '../$services/orders.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import Modal from '../$components/modal.svelte'
    import Spinner from '../$components/spinner.svelte'
    import Switch from '../$components/switch.svelte'

    const { HOST_APP } = _CONSTANTS_
    const dispatch = createEventDispatcher()

    export let store;
    export let order;
    export let pickup;
    export let delivery;
    export let ipackage;
    export let quotation;

    let loading = false

    let data = {}
    let tag = ''
    let documentFormat = 'pdf'
    let isOccurs = false
    let shipment = null
    let referenceInput = null
    let acceptTerms = false
    let merchandises = []
    let element = null

    let guidesSuccess = false
    let guidesTotal = 1
    let guidesCount = 0
    let showModal = false
    
    let done = (order && store) ? 'Órdenes' : 'Cotizador'
    let error = null

    let storeName = store ? store.name : ''
    let guideNumber = order ? order.number : ''

    uppercaseData()

    async function createShipment() {

        if(!merchandises.length)
            return toast({message: 'Se requerie registrar la mercancia que se envía', type: 'is-danger'})

        if(guidesTotal > 5)
            return toast({message: 'No se permite generar mas de 5 guías', type: 'is-info'})

        if(guidesTotal > 1)
            return showModal = true

        data = {
            tag,
            pickup,
            delivery,
            merchandises,
            documentFormat,
            isOccurs,
            packageContent: ipackage.content,
            token: quotation.token
        }

        if(store && order) {
            data.storeId = store._id
            data.orderId = order._id
            data.remoteId = order.remoteId
        }

        loading = true
        const resp = await ShipmentsService.createShipmentNational(data)
        loading = false

        if(!resp.success) {
            error = resp.error
            return toast({message: resp.error.message, type: 'is-danger'})
        }

        shipment = resp.data.shipment
        notifyStore.set('orders_updated')
    }

    async function createShipments() {

        data = {
            tag,
            pickup,
            delivery,
            merchandises,
            documentFormat,
            isOccurs,
            packageContent: ipackage.content,
            token: quotation.token
        }

        loading = true

        for(let i=0; i < guidesTotal; i++) {

            guidesCount = i + 1
            const resp = await ShipmentsService.createShipmentNational(data)

            if(!resp.success)
                return toast({message: resp.error.message, type: 'is-danger'})
        }

        loading = false
        guidesSuccess = true
    }

    async function createOrder() {

        const data = {
            pickup,
            delivery,
            package: ipackage
        }

        loading = true
        const resp = await OrdersService.createOrder(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Orden guardada', type: 'is-success'})
        replace('#/orders')
    }

    function uppercaseData() {

        pickup.contact = (pickup.contact || '').toUpperCase()
        pickup.rfc = (pickup.rfc || '').toUpperCase()
        pickup.corporate = (pickup.corporate || '').toUpperCase()
        pickup.email = (pickup.email || '').toUpperCase()
        pickup.state = (pickup.state || '').toUpperCase()
        pickup.city = (pickup.city || '').toUpperCase()
        pickup.colony = (pickup.colony || '').toUpperCase()
        pickup.street = (pickup.street || '').toUpperCase()
        pickup.number = (pickup.number || '').toUpperCase()
        pickup.apartment = (pickup.apartment || '').toUpperCase()
        pickup.references = (pickup.references || '').toUpperCase()

        delivery.contact = (delivery.contact || '').toUpperCase()
        delivery.rfc = (delivery.rfc || '').toUpperCase()
        delivery.corporate = (delivery.corporate || '').toUpperCase()
        delivery.email = (delivery.email || '').toUpperCase()
        delivery.state = (delivery.state || '').toUpperCase()
        delivery.city = (delivery.city || '').toUpperCase()
        delivery.colony = (delivery.colony || '').toUpperCase()
        delivery.street = (delivery.street || '').toUpperCase()
        delivery.number = (delivery.number || '').toUpperCase()
        delivery.apartment = (delivery.apartment || '').toUpperCase()
        delivery.references = (delivery.references || '').toUpperCase()

        ipackage.content = (ipackage.content || '').toUpperCase()
    }

    function createFile() {

        let fileName = `datos.guia${ Moment().format() }.txt`

        let stringData = `
            USUARIO
            ------------------------------------
            Nombre: ${$userStore.name}
            Correo: ${$userStore.email}
            
            CONTACTO ORIGEN
            ------------------------------------
            Contacto: ${pickup.contact}
            RFC: ${pickup.rfc}
            Corporación: ${pickup.corporate}
            Teléfono: ${pickup.phone}
            Correo: ${pickup.email}

            DIRECCION ORIGEN
            ------------------------------------
            Codigo_Postal: ${pickup.zipcode}
            Estado: ${pickup.state}
            Ciudad: ${pickup.city}
            Municipio: ${pickup.municipality}
            Colonia: ${pickup.colony}
            Calle: ${pickup.street}
            Número_Exterior: ${pickup.number}
            Número_Interior: ${pickup.apartment}
            Referencias: ${pickup.references}
            
            CONTACTO DESTINO
            ------------------------------------
            Contacto: ${delivery.contact}
            RFC: ${delivery.rfc}
            Corporación: ${delivery.corporate}
            Teléfono: ${delivery.phone}
            Correo: ${delivery.email}

            DIRECCION DESTINO
            ------------------------------------
            Codigo_Postal: ${delivery.zipcode}
            Estado: ${delivery.state}
            Ciudad: ${delivery.city}
            Municipio: ${delivery.municipality}
            Colonia: ${delivery.colony}
            Calle: ${delivery.street}
            Número_Exterior: ${delivery.number}
            Número_Interior: ${delivery.apartment}
            Referencias: ${delivery.references}
            
            PAQUETE
            ------------------------------------
            Ancho: ${ipackage.width}
            Alto: ${ipackage.height}
            Largo: ${ipackage.length}
            Peso: ${ipackage.weight}
            Volumétrico: ${quotation.package.volumetric}
            Valor: ${ipackage.value}
            Contenido: ${ipackage.content}

            MERCANCIA
            ------------------------------------
            ${ listMerchandise() }

            SERVICIO
            ------------------------------------
            Proveedor: ${quotation.provider}
            Servicio: ${quotation.service}
            Precio: ${quotation.finalPrice}
            Formato: ${documentFormat}
            Ocurre: ${isOccurs? 'SI' : 'NO'}

            DATA
            ------------------------------------
            Realizado_Desde: ${done}
            Nombre_Tienda: ${storeName}
            Número_Órden: ${guideNumber}

            ERROR
            ------------------------------------
            ${ JSON.stringify(error, null, 4) }
        `
        const blob = new Blob([stringData], {type: 'text/plain'})

        element.download = fileName
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

    function listMerchandise() {

        let str = ''

        merchandises.forEach(item => {
            str += `
                Producto: ${ item.product.name }
                Producto: ${ item.product.code }
                Items: ${ item.items }
                Peso: ${ item.weight }
                Unidad: ${ item.unit.name }
                Unidad: ${ item.unit.code }
                Valor: ${ item.value }
                Descripción: ${ item.description }
                ------------------------------------
            `
        })

        return str
    }

    function onCopy() {
        referenceInput.select()
        referenceInput.setSelectionRange(0, 99999)
        document.execCommand("copy")
        toast({message: 'Link copiado', type: 'is-success'})
    }

    function setStep(step) {
        dispatch('step', step)
    }

</script>

<a bind:this={element} href="/" style="display: none;">.</a>

<Spinner {loading} />

{#if !loading}
    {#if shipment}
        <div class="columns">
            <div class="column">
                <div class="title">Guía generada</div>
                <div class="columns">
                    <div class="column">
                        <div>Número de guía</div>
                        <div><b>{shipment.guide}</b></div>
                    </div>
                    <div class="column">
                        <div>Código</div>
                        <div>{shipment.code}</div>
                    </div>
                    <div class="column">
                        <div>
                            <a href="{shipment.document}" target="_blank">
                                <span class="icon">
                                <i class="fas fa-download"></i>
                                </span>
                                <span>Descargar aquí</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="title">Link de rastreo</div>
                        <div class="items-space-around">
                            <input bind:this={referenceInput} value={`${HOST_APP}/#/trackings/${shipment.code}`} type="text" class="input space-right" readonly>
                            <button on:click={onCopy} class="button" data-tooltip="Copiar link">
                                <span class="icon"><i class="fas fa-copy"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="items-end">
                    {#if $location === '/quotations'}
                        <button on:click={() => setStep('zipcodes')} type="button" class="button space-right">
                            <span class="icon"><i class="fas fa-truck"></i></span>
                            <span>Nuevo envío</span>
                        </button>
                    {/if}
                    <button on:click={() => replace('#/shipments')} type="button" class="button is-primary">
                        <span class="icon"><i class="fas fa-shipping-fast"></i></span>
                        <span>Ver mis envíos</span>
                    </button>
                </div>
            </div>
        </div>
    {/if}
    {#if !shipment}
        <div class="columns">
            <div class="column">
                <div class="title">Origen</div>
                <div><b>{ pickup.contact }</b></div>
                <div>{ pickup.rfc || 'Sin información' }</div>
                <div>{ pickup.corporate || 'Sin información' }</div>
                <div>{ pickup.phone }</div>
                <div>{ pickup.email }</div>
                <div>{ pickup.street }</div>
                <dd>{ pickup.number }, { pickup.apartment || '' }</dd>
                <div>{ pickup.colony }</div>
                <div><b>{ pickup.zipcode }</b> { pickup.municipality || '' }, { pickup.city }, { pickup.state }</div>
                <div>{ pickup.references }</div>
                <small><b>{ pickup.sendEmail? 'Se envía correo de confirmación' : 'No se envía correo de confirmación' }</b></small>
            </div>
            <div class="is-divider-vertical"></div>
            <div class="column">
                <div class="title">Destino</div>
                <div><b>{ delivery.contact }</b></div>
                <div>{ delivery.rfc || 'Sin información' }</div>
                <div>{ delivery.corporate || 'Sin información' }</div>
                <div>{ delivery.phone }</div>
                <div>{ delivery.email }</div>
                <div>{ delivery.street }</div>
                <div>{ delivery.number }, { delivery.apartment || '' }</div>
                <div>{ delivery.colony }</div>
                <div><b>{ delivery.zipcode }</b> { delivery.municipality || '' }, { delivery.city }, { delivery.state }</div>
                <div>{ delivery.references }</div>
                <small><b>{ delivery.sendEmail? 'Se envía correo de confirmación' : 'No se envía correo de confirmación' }</b></small>
            </div>
        </div>
        <br>
        <div class="columns">
            <div class="column">
                <div class="title">Paquete</div>
                <div>
                    { quotation.package.width }cm x { quotation.package.height }cm x { quotation.package.length }cm
                </div>
                <div>{ quotation.package.weight }Kg Físico</div>
                <div>{ quotation.package.volumetric }Kg Volumétrico</div>
            </div>
            <div class="is-divider-vertical"></div>
            <div class="column">
                <div class="title">Contenido</div>
                <div>Valor declarado ${quotation.package.value}</div>
                <div>{ ipackage.content }</div>
            </div>
        </div>
        <br>
        <div class="columns">
            <div class="column">
                <div class="title">Mercancia</div>
                <Merchandises bind:merchandises={merchandises} packageId={ipackage._id} />
            </div>
        </div>
        <br>
        <div class="columns">
            <div class="column">
                <div class="items-center col">
                    <img src="images/{quotation.provider.replace(' Partner', '')}.svg" alt="{quotation.provider}" style="max-width: 200px;">
                    <div class="title">{ quotation.service }</div>
                    {#if !$userStore.hidePrices}
                        <div class="subtitle">{ NumeralMethods.cash(quotation.finalPrice) }</div>
                    {/if}

                    {#if quotation.provider === 'EstafetaLTL'}
                        <div class="notification">Estimado Cliente, te recordamos que en caso de requerir asegurar tu pallet, debes ponerte en contacto con tu ejecutivo comercial antes de que inicie su tránsito.</div>
                    {/if}
                </div>
            </div>
            {#if !$userStore.hidePrices}
                <div class="is-divider-vertical"></div>
                <div class="column">
                    <div class="title">Detalles</div>
                    {#if (quotation.paymentType === 'wallet' || quotation.paymentType === 'account') && !$userStore.hidePrices}
                        <div class="items-space">
                            <div>Envío</div>
                            <div>${quotation.shipmentPrice}</div>
                        </div>
                    {:else if quotation.paymentType === 'prepaid'}
                        <div class="items-space">
                            <div>Envío</div>
                            <div>$0</div>
                        </div>
                    {/if}
                    {#if quotation.insurancePrice}
                        <div class="items-space">
                            <div>Seguro</div>
                            <div>${quotation.insurancePrice}</div>
                        </div>
                    {/if}
                    <div class="items-space">
                        <div>Extra</div>
                        <div>${quotation.aggregatePrice}</div>
                    </div>
                    <br>
                    <Switch bind:checked={ isOccurs } label="Entrega Ocurre" />
                    <br>
                    <div class="tags">
                        {#if isOccurs}
                            <span class="tag is-danger">Entrega Ocurre</span>
                        {/if}
                        {#if !quotation.isDeliveryHome}
                            <span class="tag is-danger">Sin entrega a domicilio</span>
                        {/if}
                        {#if quotation.isCoverageCost}
                            <span class="tag is-danger">Zona extendida</span>
                        {/if}
                        {#if quotation.paymentType === 'prepaid'}
                            <span class="tag is-primary">Guía prepago {quotation.prepaidShipments}/{quotation.prepaidShipmentsTotal}</span>
                        {/if}
                        {#if quotation.information}
                            <span class="tag is-large is-primary icon-text" style="color: white;">
                                <span>{quotation.information}&nbsp;&nbsp;</span>
                                <span on:click={() => popupStore.set('frequency_popup')} class="class-icon"><i class="fas fa-question-circle" style="color: whitesmoke; cursor: pointer;"></i></span>
                            </span>
                        {/if}
                    </div>
                </div>
            {/if}
        </div>
        {#if !shipment && !loading}
            <div class="column">
                <form on:submit|preventDefault={ createShipment }>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label for="" class="label">Generar multiples guias</label>
                                <input bind:value={ guidesTotal } type="number" class="input" placeholder="Cantidad de guías" />
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <span class="icon-text" style="color:  #363636; font-size: 1rem; font-weight: 700;">
                                    <span>Agregar un identificador personal </span>
                                    <span on:click={() => popupStore.set('identifier_popup')} class="class-icon"><i class="fas fa-question-circle" style="color: #4e598c; cursor: pointer;"></i></span>
                                </span>
                                <div class="control has-icons-left" style="margin-top: 0.5em;">
                                    <span class="icon"><i class="fas fa-tag"></i></span>
                                    <input bind:value={tag} type="text" class="input" placeholder="Identificador personal">
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label for="" class="label">Formato de guía</label>
                                <div class="control">
                                    <div class="select">
                                        <select bind:value={documentFormat}>
                                            <option value="pdf">pdf</option>
                                            <option value="6x4">6x4</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="items-end">
                                <label for="" class="label">Aceptar <a href="/" target="_blank">términos y condiciones</a></label>
                                <input bind:checked={acceptTerms} type="checkbox" class="space-left" />
                            </div>
                        </div>
                    </div>
                    <div class="items-end">
                        {#if merchandises.length}
                            <button on:click={() => createFile()} type="button" class="button space-right">
                                <span class="icon"><i class="fas fa-file-alt"></i></span>
                                <span>Descargar datos</span>
                            </button>
                        {/if}
                        {#if $location === '/quotations'}
                            <button on:click={createOrder} type="button" class="button space-right">
                                <span class="icon"><i class="fas fa-heart"></i></span>
                                <span>Guardar como orden</span>
                            </button>
                        {/if}
                        <button type="submit" class="button is-primary" disabled={!acceptTerms}>
                            <span class="icon"><i class="fas fa-truck"></i></span>
                            <span>Generar guía</span>
                        </button>
                    </div>
                </form>
            </div>
        {/if}
    {/if}
{/if}

<Modal bind:show={showModal} >
    {#if !loading && !guidesSuccess}
        <div class="title">¿Seguro que quieres generar { guidesTotal } guías?</div>
        <button on:click={ createShipments } class="button is-primary">
            <span class="icon"><i class="fas fa-check"></i></span>
            <span>Aceptar</span>
        </button>
    {/if}
    {#if loading}
        <div class="title is-4">Generando Guías</div>
        <div class="subtitle">{ guidesCount } de { guidesTotal }</div>
        <Spinner bind:loading />
    {/if}
    {#if guidesSuccess}
        <div class="title is-4">Guías Generadas</div>
        <div class="items-end">
            {#if $location === '/quotations'}
                <button on:click={() => setStep('zipcodes')} type="button" class="button space-right">
                    <span class="icon"><i class="fas fa-truck"></i></span>
                    <span>Nuevo envío</span>
                </button>
            {/if}
            <button on:click={() => replace('#/shipments')} type="button" class="button is-primary">
                <span class="icon"><i class="fas fa-shipping-fast"></i></span>
                <span>Ver mis envíos</span>
            </button>
        </div>
    {/if}
</Modal>